import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import GoogleMap, { meters2ScreenPixels } from 'google-map-react'

import colors, { alpha } from 'theme/colors'
import { image } from 'services'

export class Pin extends PureComponent {
  render() {
    return (
      <img
        src={image('map-pin.svg')}
        alt="Pin"
        style={{
          width: '32px',
          height: '60px',
          position: 'absolute',
          top: '-60px',
          left: '-16px',
          objectFit: 'contain'
        }}
      />
    )
  }
}

export const Marker = ({ children }) => (
  <span
    style={{
      width: '32px',
      height: '60px',
      position: 'absolute',
      top: '-60px',
      left: '-16px',
      objectFit: 'contain',
      color: colors.white,
      backgroundColor: colors.darkPrimary
    }}
  >{children}</span>
)


export class Circle extends PureComponent {
  render() {
    const { fill, border, radius, lat, lng, zoom = 15 } = this.props
    const { w, h } = meters2ScreenPixels(
      radius,
      { lat: parseFloat(lat), lng: parseFloat(lng) },
      zoom
    )
    return (
      <div
        style={{
          width: `${w}px`,
          height: `${h}px`,
          borderRadius: '50%',
          position: 'absolute',
          top: `-${h/2}px`,
          left: `-${w/2}px`,
          background: fill,
          borderColor: border,
          borderStyle: 'solid',
          borderWidth: 'thin'
        }}
      />
    )
  }
}

Circle.defaultProps = {
  radius: 300,
  fill: alpha(colors.primary, 0.5),
  border: alpha(colors.secondary, 0.5),
}

class Map extends PureComponent {
  render() {
    const { lat, lng, children, zoom = 15, ...rest } = this.props

    return (
      <GoogleMap
        center={Object.values({ lat: parseFloat(lat), lng: parseFloat(lng) })}
        zoom={zoom}
        {...rest}
      >
        {children}
      </GoogleMap>
    )
  }
}
export default Map
